<template>
  <div class="flex flex-col bg-light-grey p-5 rounded-xl">
    <div class="flex flex-col flex-1">
      <h2 class="text-lg text-primary-900 mb-5">
        {{ $t("home.social_media_messages") }}
      </h2>
      <div
        v-if="!omniActiveConversations || omniActiveConversations.length === 0"
        class="flex flex-col flex-1 justify-center items-center h-full"
      >
        <p class="text-primary-900 text-sm">
          {{ $t("home.no_social_media_messages") }}
        </p>
      </div>
      <div
        v-for="item in omniActiveConversations"
        :key="item.conversation_id"
        class="flex justify-between items-center bg-white p-4 mb-3 rounded-xl w-full"
      >
        <div>
          <p class="text-primary-900 text-sm">
            {{ item.customer || "" }}
          </p>
          <p class="text-primary-900 text-xs mt-1">
            {{
              item.last_message
                ? item.last_message.slice(0, 100) +
                  (item.last_message.length > 100 ? "..." : "")
                : ""
            }}
          </p>
          <div class="flex items-center gap-1 mt-2 text-xs">
            <v-icon class="text-primary-500">mdi-clock-outline</v-icon>
            <p class="text-primary-500">
              {{ getConversationTime(item.last_update) }}
            </p>
          </div>
        </div>
        <Button
          class="hover:bg-primary-900 bg-light-grey rounded-full p-2"
          @click="goToConversations()"
          rounded
        >
          <v-icon class="text-primary-500 text-3xl hover:!text-white">{{
            "mdi-eye-outline"
          }}</v-icon></Button
        >
      </div>
    </div>
    <div
      class="flex justify-center"
      v-if="omniActiveConversations && omniActiveConversations.length > 0"
    >
      <Button
        class="bg-white hover:!bg-primary-900 hover:!text-white px-5 py-3 mt-4 rounded-lg text-primary-900 border-solid border-primary-900 border"
        :label="$t('home.show_all')"
        @click="goToConversations()"
      />
    </div>
  </div>
</template>

<script>
import { Button } from "primevue";
import { mapGetters } from "vuex";
import moment from "moment";

export default {
  components: { Button },
  data() {
    return {
      socialMediaConversations: [
        {
          name: "خالد عبد الله العريج",
          message: "السلام عليكم",
          tickets: 1,
        },
        {
          name: "أحمد الشمري",
          message: "هل يمكنني الحصول على المساعدة؟",
          tickets: 2,
        },
        {
          name: "ليلى الحربي",
          message: "شكرا لدعمكم!",
          tickets: 0,
        },
      ],
    };
  },
  methods: {
    goToConversations() {
      this.$router.push(`${this.getbaseURL}/social-media/`);
    },
    getConversationTime(lastTime, type) {
      const messageDay = moment.unix(+lastTime).format("YYYY-MM-DD");
      const today = moment().format("YYYY-MM-DD");
      const sameDayCond = moment(messageDay).isSame(moment(today), "day");
      if (sameDayCond && type != 3) {
        return moment.unix(+lastTime).format("HH:mm");
      } else if (sameDayCond && type == 3) {
        return this.$t("chat.time.today");
      }
      if (moment(today).diff(moment(messageDay), "days") == 1) {
        return this.$t("chat.time.yesterday");
      }
      const weekEarlier = moment().add(-7, "days").format("YYYY-MM-DD");
      if (moment(weekEarlier).isBefore(moment(messageDay))) {
        return moment.unix(+lastTime).locale(this.currentLocal).format("dddd");
      }
      return messageDay;
    },
  },
  computed: {
    ...mapGetters(["omniActiveConversations", "getbaseURL"]),
    currentLocal() {
      return this.$vuetify.locale.current;
    },
  },
};
</script>

<style></style>
